module.exports = __webpack_public_path__ + "img/tmb.2843bf87.svg";